import type { CreateWaitMusicApiArg } from 'lib-shared-types-api';

export function transformWaitMusicCreate(
  waitMusic: CreateWaitMusicApiArg,
): Record<string, unknown> {
  const { masterFilePath, name } = waitMusic;
  return {
    master_file_path: masterFilePath,
    name,
  };
}
